import React, { Component, Fragment } from 'react'
import moment from 'moment'
import classnames from 'classnames'
import { ToolTip, Div, H2 } from '@driftt/tide-core';

import { Table } from '@driftt/tide-table'

import { CHART_NO_DATA_TEXT, lossColumns } from 'constants/ReportConstants'
import GraphContainer from 'components/Reports/EmailPerformance/Graphs'
import RowFormatter from 'components/Reports/EmailPerformance/TableRowFormatter'
import { EmptyGraphAndPage } from 'components/Reports/EmailPerformance/EmptyState'
import { roundPercentValue } from 'components/Reports/EmailPerformance/utils'

class TotalLoss extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeSection: 'BOUNCED',
      currentData: null
    }
  }

  getClassNames(activeSection) {
    const defaultClass = 'reports-data-callout-item'
    return {
      bounced: classnames(defaultClass, {
        'reports-data-callout-item--highlighted active-subsection': activeSection === 'BOUNCED'
      }),
      unsubscribed: classnames(defaultClass, {
        'reports-data-callout-item--highlighted active-subsection': activeSection === 'UNSUBSCRIBED'
      })
    }
  }

  componentDidMount() {
    this.setState({
      currentData: this.generateGraphData()
    })
  }

  changeGraphData(section) {
    this.setState({
      activeSection: section,
      currentData: this.generateGraphData(section)
    })
  }


  generateGraphData(section) {
    const { activeSection } = this.state
    const { data } = this.props
    const subField = section || activeSection
    const currentGraphData = []
    const previousGraphData = []

    const rawCurrentDates = data.byDate.current
    const rawPreviousDates = data.byDate.previous

    rawCurrentDates.forEach((date, i) => {
      const obj = [
        moment.utc(date.date).valueOf(),
        date.metrics[subField].value
      ]
      currentGraphData.push(obj)
    })

    rawPreviousDates.forEach((date, i) => {
      let y = 0
      if (date.metrics.hasOwnProperty(subField)) {
        y = date.metrics[subField].value
      }
      if (i < currentGraphData.length) {
        const obj = [
          currentGraphData[i][0],
          y
        ]
        previousGraphData.push(obj)
      }
    })
    
    return {
      current: currentGraphData,
      previous: previousGraphData
    }
  }

  generateTableRow = (email, index) => {
    const { data } = this.props
    const emailCampaignReport =  data.byEmail.find((mail) => mail.campaignId === email.campaignId)

    return RowFormatter.LostRows(emailCampaignReport, email.title, index)
  }

  
  render() {
    const { activeState, data, playbook } = this.props
    const { activeSection, currentData } = this.state
    const { bounced, unsubscribed } = this.getClassNames(activeSection)

    const { actions } = playbook
    const { action } = actions[0]

    const emailCampaigns = action.emails ? action.emails : [{...action}]

    const total = data.total

    const bouncedPercent = roundPercentValue(total.BOUNCED.value, total.ENROLLED.value)
    const unsubscribedPercent = roundPercentValue(total.UNSUBSCRIBED.value, total.ENROLLED.value)

    const hasDisplayData = (total.BOUNCED.value !== 0 || total.UNSUBSCRIBED.value !== 0)

    return (
      <Div className="email-performance-breakdown email-performance-breakdown--loss">
        {hasDisplayData ?
          <Div className="reports-data-callout">
            <ToolTip component={
                <Div className="metric-tooltip-center">
                  Total number of emails that were<br />returned to sender because the<br />recipient‘s address was invalid.
                </Div>
              } flow="up">
              <Div className={bounced}  onClick={() => this.changeGraphData('BOUNCED')}>
                <Div className="callout-header">Bounced</Div>
                <Div className="callout-large">{total.BOUNCED.value}</Div>
                <Div className="callout-subtext">({`${bouncedPercent}%`})</Div>
              </Div>
            </ToolTip>
            <ToolTip component={
                <Div className="metric-tooltip-center">
                  Total amount of people who opted<br />out of recieving emails from you.
                </Div>
              } flow="up">
              <Div className={unsubscribed}  onClick={() => this.changeGraphData('UNSUBSCRIBED')}>
                <Div className="callout-header">Unsubscribed</Div>
                <Div className="callout-large">{total.UNSUBSCRIBED.value}</Div>
                <Div className="callout-subtext">({`${unsubscribedPercent}%`})</Div>
              </Div>
            </ToolTip>
          </Div> :
          <Fragment>
            <Div className="reports-graph-data-overlay">
              <EmptyGraphAndPage />
              <H2>{CHART_NO_DATA_TEXT}</H2>
            </Div>
          </Fragment>
        }
        <Div className="reports-graph-container">
        {!!currentData && 
          <GraphContainer activeTab={activeState} graphData={currentData}/>
        }
        </Div>
        <Div className="reports-table-container">
          <Table columns={lossColumns} 
              className="email-reports-table"
              data={!!data ? emailCampaigns.map(this.generateTableRow) : []} 
          />
        </Div>
      </Div>
    )
  }
}

export default TotalLoss
